<template>
  <el-dialog
    :visible="true"
    title="轨迹日志"
    width="80%"
    @close="$emit('close')"
  >
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <el-table
      v-loading="loading"
      :data="rows"
      size="mini"
      height="380"
      empty-text="暂无轨迹日志"
    >
      <el-table-column prop="appName" label="应用" width="120" />
      <el-table-column prop="time" label="时间" width="165" />
      <el-table-column prop="content" label="内容">
        <template slot-scope="scope">
          <div class="trace-content" v-html="scope.row.content"></div>
        </template>
      </el-table-column>
      <el-table-column prop="traceLevel" label="级别" width="70" />
    </el-table>
  </el-dialog>
</template>

<script>
import api from "@/api/exceptionTaskApi";

export default {
  name: "TraceLogDialog",
  props: { docNo: { type: String, required: true } },
  data() {
    return { rows: [], loading: true, error: "" };
  },
  async created() {
    try {
      const res = await api.traceDetail({ bizId: this.docNo });
      this.rows = res.tracelogItems || [];
    } catch (error) {
      this.error = "轨迹日志加载失败，请关闭后重试";
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.trace-content {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
